import Pagenation from "components/Pagenation";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import monitorImg01 from "../../images/monitor_img01.png";
import {
  FirefightingActionEnum,
  GeneralUserTypeChoice,
  getFirefightingActionEnumName,
} from "utils/common";
import { apiWrapper } from "apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import * as accountApi from "../../apis/AccountApi";
import { getDateTime } from "utils/date";
import { connectRealtimeDashboardWebSocket } from "websock/realtimeDashboardManager";
import fireAlarm01 from "audio/alarm_sample01.mp3";
import fireAlarm02 from "audio/alarm_sample02.mp3";
import fireAlarm03 from "audio/alarm_sample03.mp3";
import fireAlarm04 from "audio/alarm_sample04.mp3";
import fireAlarm05 from "audio/alarm_sample05.mp3";
import fireAlarm06 from "audio/alarm_sample06.mp3";
import { connectWebSocket } from "websock/serverMessageManager";
import { useAppContext } from "utils/store";
import FireOnToolbar from "./FireOnToolbar";
import useInterval from "utils/useInterval";
import isEqual from "lodash/isEqual";

const alarmSrcs = {
  1: fireAlarm01,
  2: fireAlarm02,
  3: fireAlarm03,
  4: fireAlarm04,
  5: fireAlarm05,
  6: fireAlarm06,
};

export default function FireAlarmMonitorComponent(props) {
  const {
    store: { id: userId },
  } = useAppContext();
  let { id } = useParams();
  const [ledStatus, setLedStatus] = useState(null);
  const [actionList, setActionList] = useState([]);
  const [queryTime, setQueryTime] = useState(null);
  const [isAllowedSound, setIsAllowedSound] = useState(false);
  const isAllowedSoundRef = useRef(isAllowedSound);
  const audio = new Audio(null);
  const [firefightingObject, setFireFightingObject] = useState(null);
  const [isDetectedFire, setIsDetectedFire] = useState(false);

  useEffect(() => {
    connectRealtimeDashboardWebSocket(id, (data) => {
      setLedStatus(data.ledStatus);
      setActionList(data.actionList);
      setQueryTime(getDateTime(new Date(data.time)));

      //화재 감지 여부
      if (
        data.ledStatus[3] === 1 ||
        data.ledStatus[4] === 1 ||
        data.ledStatus[5] === 1 ||
        data.ledStatus[6] === 1 ||
        data.ledStatus[7] === 1
      ) {
        setIsDetectedFire(true);
      } else {
        setIsDetectedFire(false);
      }
    });
    connectWebSocket(userId, (data) => {
      const message = `🔔 ${data.title}: ${data.body}`;

      if (isAllowedSoundRef.current) {
        audio.src = alarmSrcs[data.type];
        audio.oncanplaythrough = () => {
          audio.play().then(() => {
            alert(message);
          });
        };
      } else {
        alert(message);
      }
    });

    getData();
  }, []);

  useEffect(() => {
    isAllowedSoundRef.current = isAllowedSound;
  }, [isAllowedSound]);

  const getData = () => {
    apiWrapper(async () => {
      const { status, data } = await fireonApi.getFireFightingObjectById(id);
      if (status === true) {
        setFireFightingObject(data);
      }
    });
  };

  const handleSound = () => {
    if (
      window.confirm(
        "화재경보 알람 소리 발생을 허용하시겠습니까?\r\n(허용하지 않을 경우 화재경보 알람 발생 시 소리가 나지 않습니다.)"
      )
    ) {
      setIsAllowedSound(true);
    } else {
      setIsAllowedSound(false);
    }
  };

  return (
    <>
      {firefightingObject && (
        <FireOnToolbar
          item="화재수신기 모니터"
          buildingName={firefightingObject.buildingName}
          serialNumber={firefightingObject.serialNumber}
          dei={firefightingObject.dei}
        />
      )}
      {firefightingObject && ledStatus && (
        <MonitorBoard
          firefightingObject={firefightingObject}
          currentDateTime={props.currentDateTime}
          ledStatus={ledStatus}
          isDetectedFire={isDetectedFire}
          getData={getData}
        />
      )}
      <TableBoard
        handleSound={handleSound}
        isAllowedSound={isAllowedSound}
        queryTime={queryTime}
        dataSource={actionList}
      />
    </>
  );
}

const MonitorBoard = ({
  firefightingObject,
  currentDateTime,
  ledStatus,
  isDetectedFire,
  getData,
}) => {
  let { id } = useParams();
  const {
    store: { id: userId },
  } = useAppContext();
  const [generalUserType, setGeneralUserType] = useState(
    GeneralUserTypeChoice.FIRE_SAFETY_ADMIN
  );
  const [circuits, setCircuits] = useState([]);
  const [firefightingActions, setFirefightingActions] = useState([]);
  const [isOnFireRecovery, setIsOnFireRecovery] = useState(false);
  const [isVisibleLogo, setIsVisibleLogo] = useState(true);
  const [isToggledDetectedFire, setIsToggledDetectedFire] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [isActivateAnimation, setIsActivateAnimation] = useState(true);

  useEffect(() => {
    setFormDataProperty("circuitZone1", firefightingObject.circuitZone1);
    setFormDataProperty("circuitZone2", firefightingObject.circuitZone2);
    setFormDataProperty("circuitZone3", firefightingObject.circuitZone3);
    setFormDataProperty("circuitZone4", firefightingObject.circuitZone4);
    setFormDataProperty("circuitZone5", firefightingObject.circuitZone5);

    apiWrapper(async () => {
      const { status, data } = await accountApi.getUser(userId);
      if (status === true) {
        if (data.generalData) {
          setGeneralUserType(data.generalData.userType);
        }
      }
    });
  }, []);

  useEffect(() => {
    const data = ledStatus;
    setCircuits([
      {
        action: `${firefightingObject.circuitZone1}`,
        isOn: data[3] === 1,
        isRed: false,
      },
      {
        action: `${firefightingObject.circuitZone2}`,
        isOn: data[4] === 1,
        isRed: false,
      },
      {
        action: `${firefightingObject.circuitZone3}`,
        isOn: data[5] === 1,
        isRed: false,
      },
      {
        action: `${firefightingObject.circuitZone4}`,
        isOn: data[6] === 1,
        isRed: false,
      },
      {
        action: `${firefightingObject.circuitZone5}`,
        isOn: data[7] === 1,
        isRed: false,
      },
      { action: "발신기 동작", isOn: data[20] === 1, isRed: true },
    ]);

    const newFirefightningActions = [
      {
        action: FirefightingActionEnum.ACCUMULATION,
        isOn: data[8] === 1,
        isRightButton: false,
        buttonStatus: "",
      },
      {
        action: FirefightingActionEnum.CIRCUIT_BUZZER,
        isOn: data[13] === 0,
        isRightButton: true,
        buttonStatus: "",
      },
      {
        action: FirefightingActionEnum.GUIDING_LIGHT,
        isOn: data[9] === 1,
        isRightButton: false,
        buttonStatus: "",
      },
      {
        action: FirefightingActionEnum.MAIN_ALARM,
        isOn: data[14] === 0,
        isRightButton: true,
        buttonStatus: "red-on",
      },
      {
        action: FirefightingActionEnum.INDICATOR_LIGHT,
        isOn: data[10] === 1,
        isRightButton: false,
        buttonStatus: "",
      },
      {
        action: FirefightingActionEnum.LOCAL_ALARM,
        isOn: data[15] === 0,
        isRightButton: true,
        buttonStatus: "red-on",
      },
      {
        action: FirefightingActionEnum.FIRE_ALARM,
        isOn: data[11] === 1,
        isRightButton: false,
        buttonStatus: "",
      },
      {
        action: FirefightingActionEnum.AUTO_RECOVERY,
        isOn: data[16] === 1,
        isRightButton: true,
        buttonStatus: "",
      },
      {
        action: FirefightingActionEnum.OPERATION_TEST,
        isOn: data[12] === 1,
        isRightButton: false,
        buttonStatus: "",
      },
      //화재복구 버튼은 예외적으로 동작시키기 위해 주석처리
      //{ action: FirefightingActionEnum.FIRE_RECOVERY, isOn: data[17] === 1, isRightButton: true, buttonStatus: 'red-on' },
    ];

    //하나라도 바뀌었으면 다시 설정
    if (isEqual(firefightingActions, newFirefightningActions) === false) {
      setFirefightingActions(newFirefightningActions);

      handleRestartAnimation();
    }
  }, [ledStatus]);

  useInterval(
    () => {
      setIsVisibleLogo(!isVisibleLogo);
    },
    5000,
    isDetectedFire === false
  );

  useInterval(
    () => {
      setIsToggledDetectedFire(!isToggledDetectedFire);
    },
    1000,
    isDetectedFire
  );

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleControl = (action, isOn) => {
    if (action === FirefightingActionEnum.FIRE_RECOVERY) {
      //화재복구 버튼 클릭 시에는 1초 점등 후 소등
      setIsOnFireRecovery(true);
      setTimeout(() => {
        setIsOnFireRecovery(false);
      }, 1000);
    }

    apiWrapper(async () => {
      const { status, data } = await fireonApi.controlFireFightingObject(
        id,
        action,
        isOn
      );
      alert(`${data}`);
    });
  };

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = {
          circuitZone1: formData.circuitZone1,
          circuitZone2: formData.circuitZone2,
          circuitZone3: formData.circuitZone3,
          circuitZone4: formData.circuitZone4,
          circuitZone5: formData.circuitZone5,
        };

        const result = await fireonApi.updateCircuitZones(id, requestBody);

        const { status, data } = result;
        alert(`${data}`);

        if (status === true) {
          closeModal();

          //성공 시 새로고침
          getData();
        }
      });
    }
  };

  const checkValid = () => {
    return true;
  };

  const handleRestartAnimation = () => {
    setIsActivateAnimation(false);

    setTimeout(() => {
      setIsActivateAnimation(true);
    }, 500);
  };

  return (
    <>
      <div className="monitorBoard">
        <div className="buildingInfoPanel">
          <p className="name">{firefightingObject.buildingName}</p>
          <p className="address">{`${firefightingObject.roadAddress} ${firefightingObject.roadAddressDetail}`}</p>
        </div>

        <div className="titlePanel">
          <div className="wrap_title">
            <p className="title">화재구역</p>
            {(generalUserType === GeneralUserTypeChoice.FIRE_SAFETY_ADMIN ||
              generalUserType ===
                GeneralUserTypeChoice.ASSISTANT_SAFETY_ADMIN) && (
              <button className="btn-edit" onClick={openModal}>
                구역명 편집
              </button>
            )}
          </div>
          <div className="sub_title">
            <p>일련번호 : {firefightingObject.serialNumber}</p>
            <p>DEI 코드 : {firefightingObject.dei}</p>
          </div>
        </div>

        <div className="controlPanel">
          <div className="wrap_panel wrap_le">
            {circuits.length > 0 &&
              circuits.map((circuit, index) => (
                <div
                  key={index}
                  className={`item_panel ${circuit.isRed ? "red_panel" : ""} ${
                    circuit.isOn ? "on" : ""
                  }`}
                >
                  <div className="status_cir"></div>
                  <div className="item_title">
                    <p className={`title ${circuit.isRed ? "red_title" : ""}`}>
                      {circuit.action}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <div className="wrap_panel wrap_ri">
            <div className="wrap_row">
              <div className="wrap_inner_row">
                <div
                  className={`item_panel w-type2 ${
                    ledStatus[0] === 1 ? "on" : ""
                  }`}
                >
                  <div className="status_cir"></div>
                  <div className="item_title">
                    <p className="title">상용전원</p>
                  </div>
                </div>
                <div className="item_panel item_duble_panel">
                  <div
                    className={`item_inner ${ledStatus[1] === 1 ? "on" : ""}`}
                  >
                    <div className="status_cir"></div>
                    <div className="item_title">
                      <p className="title">예비전원</p>
                    </div>
                  </div>
                  <div
                    className={`item_inner right ${
                      ledStatus[2] === 1 ? "on" : ""
                    }`}
                  >
                    <div className="item_title">
                      <p className="title">배터리 이상</p>
                    </div>
                    <div className="status_cir right"></div>
                  </div>
                </div>
              </div>
              <div
                className={`item_panel item_green ${
                  ledStatus[18] === 1 ? "on" : "off"
                }`}
              >
                <div className="status_cir"></div>
                <div className="item_title">
                  <p className="title">통신</p>
                </div>
              </div>
            </div>
            <div className="wrap_monitor">
              <div
                className={`monitor-view ${(() => {
                  let viewType = "view02";

                  //화재 감지
                  if (isDetectedFire) {
                    if (isToggledDetectedFire) {
                      viewType = "view03";
                    } else {
                      viewType = "view04";
                    }
                  }

                  return viewType;
                })()}`}
              >
                <div className="info-wrap">
                  <p className="date">{currentDateTime}</p>
                  <p className="connection-status">
                    LTE
                    <i className="x-icon"></i>
                  </p>
                </div>

                {isDetectedFire ? (
                  //화재 감지 시 화면
                  <div className="mid-wrap">
                    <p>
                      {(() => {
                        const messages = [];

                        // 화재구역 1
                        if (ledStatus[3] === 1) {
                          messages.push("1");
                        }
                        // 화재구역 2
                        if (ledStatus[4] === 1) {
                          messages.push("2");
                        }
                        // 화재구역 3
                        if (ledStatus[5] === 1) {
                          messages.push("3");
                        }
                        // 화재구역 4
                        if (ledStatus[6] === 1) {
                          messages.push("4");
                        }
                        // 화재구역 5
                        if (ledStatus[7] === 1) {
                          messages.push("5");
                        }

                        return (
                          "화재구역: " +
                          (messages.length > 0 ? messages.join(", ") : "")
                        );
                      })()}
                    </p>
                    <p>화재 감지!!!</p>
                  </div>
                ) : //평상 시 화면
                isVisibleLogo ? (
                  <div className="mid-wrap">
                    <img src={monitorImg01} alt="알엠테크솔루션" />
                  </div>
                ) : (
                  <>
                    <div className="mid-wrap">
                      <p>스마트 IoT 화재수신기</p>
                      <p>(P형 수신기)</p>
                    </div>
                    <div className="status-wrap">
                      <p className="date">동작 상태 : </p>
                      <p className="date">
                        {(() => {
                          const messages = [];

                          // 입력회로단락 상태 확인
                          // 입력회로단락 상태는 5개로 5비트 데이터
                          if (ledStatus[19] !== 0) {
                            const shortCircuits = [...Array(5)]
                              .map((_, index) => index + 1) // 1부터 5까지의 숫자 생성
                              .filter(
                                (bit) =>
                                  (ledStatus[19] & (1 << (bit - 1))) !== 0
                              ); // 비트가 1인지 확인
                            messages.push(
                              `입력회로단락(${shortCircuits.join(",")})`
                            );
                          }

                          // 교류전원 이상 상태 확인
                          if (ledStatus[0] === 0) {
                            messages.push("교류전원 이상");
                          }

                          // 배터리 이상 상태 확인
                          if (ledStatus[2] === 1) {
                            messages.push("배터리 이상");
                          }

                          // 메시지가 없으면 "정상" 표시
                          return messages.length > 0
                            ? messages.join(", ")
                            : "정상";
                        })()}
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div class="wrap_col wrap_half">
              {firefightingActions.length > 0 &&
                firefightingActions.map((item, index) => (
                  <div
                    key={index}
                    className={`item_panel ${item.buttonStatus}`}
                  >
                    <div
                      className={`status_cir ${item.isOn ? "falf_red" : ""} ${
                        item.isRightButton ? "right" : "left"
                      } ${isActivateAnimation ? "" : "stop"}`}
                    ></div>
                    <div className="item_title">
                      <p className="title">
                        {getFirefightingActionEnumName(item.action)}
                      </p>
                    </div>
                    <button
                      className="status_cir type2"
                      onClick={() => handleControl(item.action, !item.isOn)}
                    ></button>
                  </div>
                ))}
              <div className={`item_panel red-on`}>
                <div
                  className={`status_cir ${
                    isOnFireRecovery ? "falf_red" : ""
                  } right`}
                ></div>
                <div className="item_title">
                  <p className="title">
                    {getFirefightingActionEnumName(
                      FirefightingActionEnum.FIRE_RECOVERY
                    )}
                  </p>
                </div>
                <button
                  className="status_cir type2"
                  onClick={() =>
                    handleControl(FirefightingActionEnum.FIRE_RECOVERY, true)
                  }
                ></button>
              </div>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <div id="modal" className="modal darkModal circuitZoneModal show">
            <div className="modal-content">
              <div className="modal_inner">
                <p className="modal_title">화재구역명 편집</p>
                <form className="input_board" onSubmit={handleSave}>
                  <div className="wrap_inner">
                    <div className="inner_input_board">
                      <div className="input_item">
                        <p className="title_input">회로 1</p>
                        <div className="wrap_input">
                          <input
                            className="darkInput"
                            type="text"
                            placeholder="화재구역1"
                            name="circuitZone1"
                            value={formData.circuitZone1}
                            onChange={onChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="input_item">
                        <p className="title_input">회로 2</p>
                        <div className="wrap_input">
                          <input
                            className="darkInput"
                            type="text"
                            placeholder="화재구역2"
                            name="circuitZone2"
                            value={formData.circuitZone2}
                            onChange={onChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="input_item">
                        <p className="title_input">회로 3</p>
                        <div className="wrap_input">
                          <input
                            className="darkInput"
                            type="text"
                            placeholder="화재구역3"
                            name="circuitZone3"
                            value={formData.circuitZone3}
                            onChange={onChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="input_item">
                        <p className="title_input">회로 4</p>
                        <div className="wrap_input">
                          <input
                            className="darkInput"
                            type="text"
                            placeholder="화재구역4"
                            name="circuitZone4"
                            value={formData.circuitZone4}
                            onChange={onChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="input_item">
                        <p className="title_input">회로 5</p>
                        <div className="wrap_input">
                          <input
                            className="darkInput"
                            type="text"
                            placeholder="화재구역5"
                            name="circuitZone5"
                            value={formData.circuitZone5}
                            onChange={onChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="btn-wrap">
                    <button type="submit" className="modal_btn add_btn">
                      저장
                    </button>
                    <button
                      type="button"
                      className="modal_btn add_btn"
                      onClick={closeModal}
                    >
                      취소
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const TableBoard = ({ handleSound, isAllowedSound, queryTime, dataSource }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    store: { userName },
  } = useAppContext();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleExportExcel = () => {
    apiWrapper(async () => {
      const { status, data } =
        await fireonApi.downloadExcelFireFightingObjectActionList(id);
      if (status === false) {
        alert(`엑셀 저장에 실패하였습니다.\n${data}`);
      }
    });
  };

  const handleClose = () => {
    if (window.confirm("현재 창을 닫으시겠습니까?")) {
      window.close();
    }
  };

  return (
    <div className="viewBoard fireOnBoard tableBoard">
      <div className="top_board navi_board pc">
        <div className="wrap_navi">
          <p className="title_navi">화재수신기 모니터</p>
        </div>
        <div className="wrap_right pc">
          <div className="wrap_userBox">
            <div className="wrap_userInfo pc">
              <p className="current_date">{getDateTime(new Date(queryTime))}</p>
            </div>
            <p className="user_id">{userName}</p>
          </div>
          <div className="user_contr">
            <button
              className="btn_contr btn_sound pc"
              onClick={handleSound}
              title="경보음 켜기/끄기"
            >
              <i className="x-icon">{`${isAllowedSound ? "" : ""}`}</i>
            </button>
            <button
              className="btn_contr pc"
              onClick={handleClose}
              title="창 닫기"
            >
              <i className="x-icon"></i>
            </button>
          </div>
        </div>
      </div>
      <div className="mid_board">
        <div className="wrap_mid_le">
          <p className="title_mid">화재수신기 동작 이력</p>
        </div>
        <div className="wrap_mid_ri">
          <button className="btn-excel" onClick={handleExportExcel}>
            엑셀
          </button>
        </div>
      </div>
      <div className="table_board scroll_board">
        <div className="wrap_table">
          <div className="containerTable monitorTable">
            <ul className="head_table">
              <li>
                <p>발생 일시</p>
              </li>
              <li>
                <p>이벤트 명</p>
              </li>
              <li>
                <p>동작위치</p>
              </li>
            </ul>
            <div className="body_table">
              <div className="inner_table_wrap">
                {dataSource.length > 0 &&
                  dataSource.map((item, index) => (
                    <div key={index} className="wrap_table_item">
                      <div className="inner_table_item table_item_01">
                        <p className="cont_table_item">
                          {getDateTime(new Date(item.time))}
                        </p>
                      </div>
                      <div className="inner_table_item table_item_02">
                        <p className="cont_table_item">{item.eventName}</p>
                      </div>
                      <div className="inner_table_item table_item_03">
                        <p className="cont_table_item">{item.actionLocation}</p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrap_controll type-start type-black mb">
        <div className="wrap_btn_set">
          <button className="btn_set btn_cancle">취소</button>
          <button className="btn_set btn_save">저장</button>
        </div>
        <div id="pagination">
          <Pagenation />
        </div>
      </div>
    </div>
  );
};
